import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const CampAttendanceSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Camp Attendance Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'Customer',
                                key: 'owner',
                                format: 'ModelLink'
                            },
                            {
                                label: 'Athlete',
                                key: 'athlete',
                                format: 'ModelLink'
                            },
                            {
                                label: 'Host',
                                key: 'host',
                                format: 'ModelLink'
                            },
                            {
                                label: 'Status',
                                key: 'status',
                                format: 'ModelLink'
                            },
                        ]}
                        columnB={[
                            {
                                label: 'Joined On',
                                key: 'joinedOn',
                                format: 'OnAndBy'
                            },  
                            {
                                label: 'SessionDate',
                                key: 'sessionDate',
                                format: 'date'
                            },                            
                            {
                                label: 'SessionGroup',
                                key: 'sessionGroup',
                                format: 'ModelLink'
                            },
                            {
                                label: 'Session',
                                key: 'session',
                                format: 'ModelLink'
                            },
                        ]}
                        columnC={[

                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default CampAttendanceSingleView;
